/**
 * api接口统一管理
 */
import { get, post, jsonp } from './http'
import events from '@/bus/bus'

/**
 * 获取字体列表
 */
export const getFontList = p => get('/api/v2/font/getfontlist', p)

/**
 * 获取ai资产数
 * @param {*} p
 * @returns
 */
export const getUserAiTimes = p => get('/api/v1/photosir/assets/get?funcname=AITIMES', p)

/**
 * 记录登录日志
 * @param {Object} p 请求参数
 */
export const saveVisitLog = p => jsonp('/api/v1/log/visit', p)

/**
 * 账号登录
 * @param {*} p
 * @returns
 */
export const accountLogin = p => post('/api/v1/pc/pclogin', p)

/**
 * 验证码登录
 * @param {*} p
 * @returns
 */
export const checkcodeLogin = p => post('/api/v1/pc/checkcode', p)

/**
 * 获取验证码
 * @param {*} p
 * @returns
 */
export const sendCommonCode = p => post('/api/v1/pc/sendCommonCode', p)

/**
 * 生成方式
 * @param {*} p
 * @returns
 */
export const queryparambyname = p => get('/api/v1/common/queryparambyname', p)

/**
 * 更多风格
 * @param {*} p
 * @returns
 */
export const queryall = p => get('/api/v2/tool/ai/style/queryall', p)

/**
 * 组织风格列表
 * @param {*} p
 * @returns
 */
export const queryOrganizeStyle = p => get('/api/v2/tool/ai/style/querybyorganize', p)

/**
 * H5获取生成图层
 * @param {*} p photoid 0表示第一个 sortrule 1上一张 2下一张(photoid=0时不起作用)
 * @returns
 */
export const getaigcphoto = p => get('/api/v4/space/getaigcphoto', p)

/**
 * 做同款
 * @param {*} p
 * @returns
 */
export const gcsame = p => jsonp('/api/v4/tool/aigc/sd/gcsame', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 图像扩展
 * @param {*} p
 * @returns
 */
export const inpaintgetimg = p => jsonp('/api/v4/tool/aigc/sd/inpaint', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 局部替换
 * @param {*} p
 * @returns
 */
export const replace = p => jsonp('/api/v4/tool/aigc/sd/replace', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 局部擦除
 * @param {*} p
 * @returns
 */
export const remove = p => jsonp('/api/v4/tool/aigc/sd/remove', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 文生图
 * @param {*} p
 * @returns
 */
export const textgetimg = p => post('/api/v3/tool/aigc/sd/textgetimg', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 图生图
 * @param {*} p
 * @returns
 */
export const imggetimg = p => post('/api/v3/tool/aigc/sd/imggetimg', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 生成景深、色块（语义）、轮廓图
 * @param {*} p
 * @returns
 */
export const typegetimg = p => post('/api/v3/tool/aigc/sd/typegetimg', p)

/**
 * 高清放大
 * @param {*} p
 * @returns
 */
export const extrasforimg = p => post('/api/v3/tool/aigc/sd/extrasforimg', p).finally(function () {
  setTimeout(function () {
    events.emit('refreshAiTimes')
  }, 1000)
})

/**
 * 主体识别
 * @param {*} p
 * @returns
 */
export const subjectIdentification = p => post('/api/v2/tool/imageMatting', p)

/**
 * AI识别
 * @param {*} p
 * @returns
 */
export const segmentDetect = p => post('/api/v3/tool/aigc/sd/segmentdetect', p)

/**
 * 保存当前所有数据到服务器
 * @param {*} p
 * @returns
 */
export const saveToServe = p => post('/api/v3/tool/aigc/sd/uploadgcfile', p)

/**
 * 修改服务器上某图片类型
 * @param {*} p
 * @returns
 */
export const modifyToServe = p => post('/api/v3/tool/aigc/sd/changeimagetype', p)

/**
 * 获取服务器上所有数据
 * @param {*} p
 * @returns
 */
export const getToServe = p => get('/api/v3/tool/aigc/sd/listpageuserhistory', p)

/**
 * 删除服务器上某组数据
 * @param {*} p
 * @returns
 */
export const delToServe = p => post('/api/v3/tool/aigc/sd/deleteaigc', p)

/**
 * 获取画廊列表数据
 * @param {*} p
 * @returns
 */
export const getGalleryList = p => get('/api/v3/tool/aigc/sd/listpagegallery', p)

/**
 * 获取我的画廊列表数据
 * @param {*} p
 * @returns
 */
export const getMyGalleryList = p => get('/api/v3/tool/aigc/sd/listpagemygallery', p)

/**
 * 点赞画廊列表中某图片
 * @param {*} p
 * @returns
 */
export const loveGallery = p => post('/api/v3/tool/aigc/sd/love', p)

/**
 * 取消点赞画廊列表中某图片
 * @param {*} p
 * @returns
 */
export const cancelLoveGallery = p => post('/api/v3/tool/aigc/sd/cancellove', p)

/**
 * 共享画廊列表中某图片
 * @param {*} p
 * @returns
 */
export const shareGallery = p => post('/api/v3/tool/aigc/sd/shared', p)

/**
 * 取消共享画廊列表中某图片
 * @param {*} p
 * @returns
 */
export const cancelShareGallery = p => post('/api/v3/tool/aigc/sd/cancelshared', p)

/**
 * 获取微信客服群二维码接口（GET）
 * @param {Object} p 请求参数
 */
export const getWeChatCustomerQrCodeApi = p => get('/api/v1/common/queryparambyname', p)

/**
 * 获取微信客服群二维码接口（GET）
 * @param {Object} p 请求参数
 */
export const getwxconfig = p => get('/api/v1/common/getwxconfig', p)

/**
 * 控制全局共享(post)s
 * @param {Number} 0 不共享 1共享
 *
 */
export const shareAction = p => post('/api/v3/tool/aigc/sd/isshare', p)

/**
 * 查询（分享/水印）设置状态
 *
 */
export const getUserSetting = p => get('/api/v3/tool/aigc/sd/usershare')

/**
 * 控制全局AI生图中的是否带水印(post)s
 * @param {Number} 0 生成的图还有水印 1 生成的图没有水印
 *
 */
export const nowaterAction = p => post('/api/v3/tool/aigc/sd/isnowater', p)

/**
 * 获取标题接口
 */
export const getTitleApi = p => get('/api/v2/tool/gettitle', p)

/**
 * 获取试试手气或提示词接口
 * @param page
 * @param limit
 * @param topictype
 * @param titleid
 */
export const getTemplate = p => get('/api/v2/tool/gettemplate', p)
// 获取每日签到任务列表
export const getattendanceList = p => get('/api/v1/ai/task/attendancelist', p)

// 签到接口
export const userAttendance = p => post('/api/v1/ai/task/attendance', p)

// 获取新手村任务
export const getTask = p => get('/api/v1/ai/task/list', p)

/**
 * 领取点数接口
 */
export const claim = p => post('/api/v1/ai/task/claim', p)
/**
 * 邀请下载
 * @param {*} p
 * @returns
 */
export const invite = p => post('/api/v1/pc/invit', p)

/**
 * 点赞/取消点赞
 接口路径：/api/v4/space/usergc/love
 传输方式：post
 参数：formdata
 {
   "gcid": 1          // 相片gcid
   "status": 1        // 0 取消 1 点赞
 }
 返回数据：
 {
   "code": 0
 }
 */
// 点赞
export const pressLove = p => jsonp('/api/v4/space/community/love', p)
// 取消点赞
export const cancelpressLove = p => jsonp('/api/v4/space/community/cancellove', p)

/**
 * 点赞/取消收藏
 接口路径：/api/v4/space/usergc/love
 传输方式：post
 参数：formdata
 {
   "gcid": 1          // 相片gcid
   "status": 1        // 0 取消 1 点赞
 }
 返回数据：
 {
   "code": 0
 }
 */
// 收藏 / 取消收藏
export const addCollect = p => jsonp('/api/v4/space/community/collect', p)

export const cancelcollect = p => jsonp('/api/v4/space/community/cancelcollect', p)

// 关注
export const follow = p => jsonp('/api/v1/album/user/follow', p)

// 取消关注
export const cancelfollow = p => jsonp('/api/v1/album/user/cancelfollow', p)

/**
 * 共享
 * @param { gcid } p
 * @returns
 */
export const share = p => jsonp('/api/v4/community/gc/share', p)

/**
 * 取消共享
 * @param { gcid } p
 * @returns
 */
export const cancleshare = p => jsonp('/api/v4/community/gc/cancleshare', p)

/**
 * 发布评论
 * @param { photoid, parentid , content, url, surl } p
 * @returns
 * /api/v4/space/usergc/save
 */
export const postComments = p => jsonp('/api/v4/space/discuss/save', p)

/**
 * 评论列表查询
 * @param { photoid 当前id, parentid 回复的评论id, currentpage 当前页, pagesize 每页条数} p
 * @param { gcid、parentid、currentpage、pagesize} p
 * @returns
 * /api/v4/space/usergc/list
 */
export const getCommentList = p => get('/api/v4/space/discuss/list', p)

/**
 * 删除评论
 * @param { id 0 or 回复的评论id } p
 * @returns
 * /api/v4/space/usergc/del
 */
export const commentDel = p => jsonp('/api/v4/space/discuss/del', p)

/**
 * 评论点赞
 * @param {id 评论id} p
 * @returns
 * /api/v4/space/usergc/discusslove
 */
export const commentLove = p => jsonp('/api/v4/space/discuss/love', p)

/**
 * 评论取消点赞
 * @param {id 评论id} p
 * @returns
 * /api/v4/space/usergc/canceldiscusslove
 */
export const commentCancelLove = p => jsonp('/api/v4/space/discuss/cancellove', p)

/**
 * 上传青牛需要的凭证接口
 * @param {*} p
 * @returns
 */
export const getUploadToken = p => post('/api/v1/album/photo/initiatemultipartupload', p)

/**
*上传青牛需要的凭证接口(新)
* @param {*} p
* @returns
*/
export const getUpToken = p => jsonp('/api/v4/album/photo/getuptoken', p)

/**
* qiniu上传图片校验
* @param {*} p
* @returns
*/
export const checkfileurl = p => jsonp('/api/v4/album/photo/checkfileurl', p)

/**
 * 社区显示详情
 * @param {*} p
 * @returns
 */
export const getbygcid = p => get('/api/v4/community/gc/getbygcid', p)

/**
 * 上传到云空间
 * @param {} P
 * @returns
 */
export const uploadPosterDesign = P => post('/api/v1/album/photo/savebytype', P)

/**
 * 生成图片
 * @param {*} p
 * @returns  返回gcid
 */
export const generateImg = p => jsonp('/api/v4/tool/aigc/sd/gc', p)

/**
 * 生成图片
 * @param {*} p
 * @returns  返回gcid
 */
export const gcforeditGenerateImg = p => jsonp('/api/v4/tool/aigc/sd/gcforedit', p)

/**
 * 轮询接口
 * @param {} p
 * @returns
 */
export const getResultByGcid = p => get('/api/v4/tool/aigc/sd/getbygcid', p)

/**
 * 轮询接口
 * @param {} p
 * @returns
 */
export const getResultByGcidNew = p => get('/api/v1/aigc/motioncomics/getbygcid', p)

/**
 * 终止生成接口
 * @param { gcid: '', type: 'gcvideo' } p
 * @returns
 */
export const stopByGcid = p => jsonp('/api/v1/aigc/motioncomics/stopbygcid', p)

/**
 * 查询明细
 * @param {} p
 * @returns
 */
export const getOtherResultByGcid = p => get('/api/v4/community/gc/getbygcid', p)

/**
 * 查询图片列表
 * @param {*} p
 * @returns
 */
// export const getusergclist = p => get('/api/v4/tool/aigc/sd/getusergclist', p)

/**
 * 删除组
 */
export const deleteGc = p => jsonp('/api/v4/tool/aigc/sd/deletegc', p)
/**
 * 删除单个图片
 * @param {*} p
 * @returns
 */
export const deleteImg = p => jsonp('/api/v4/album/photo/delete', p)

/**
 * 图片精修
 * @param {*} P
 * @returns
 */
export const extrasforImg = P => jsonp('/api/v4/tool/aigc/sd/extrasforimg', P)

/**
 * 提取控制图  “filetype”:     // stroke 线稿 depth 景深  swatches 色块
 * @param {*} p
 * @returns
 */
export const getControlImg = p => jsonp('/api/v4/tool/aigc/sd/typegetimg', p)

/**
 * 选定一张
 * @param {*} p
 * @returns
 */
export const confirmImg = p => jsonp('/api/v4/tool/aigc/sd/confirm', p)

export const uploadFile = p => post('/api/v4/tool/aigc/sd/uploadfile', p)

/**
 * 首页统计数据接口：(“我的” 动态/关注/粉丝/收藏 数量获取)
 */
export const listStatistics = p => get('/api/v1/album/community/liststatistics', p)

/**
 * 云空间文件夹列表接口
 接口路径：api/v4/album/myalbum
 传输方式：get
 参数：json
 {
   "currentpage": 1,   // 页码
   "pagesize": 800,    // 每页条数(最多800条)
   "albumclass": 1     // 相册分类: 1 个人  2  企业
   "fatherid": 0       // 一级文件夹列表 传 0 ; 二级或二级以上文件夹列表 传 相册id
   "albumtype": -1     // 相册分类: 默认值 -1 表示不限制  (0 私有; 1 公开; 2 密码; 3 自定义权限; 5 AI视频; 6 AIGC生图; 7 AI生成海报; 8 海报; 9 默认相册;）
 }
 返回数据：
 {
   code: 0,
   data: {
     total: 0,         // 总条数
     albumList: []     // 文件夹列表
   }
 }
 */
export const myalbum = p => { return get('/api/v4/album/myalbum', p) }

/**
 * 云空间新增/修改文件夹接口
 接口路径：api/v4/album/add
 传输方式：get
 参数：json
 {
   "title": "",        // 名字
   "albumclass": 1,    // 相册分类: 1 个人  2  企业
   "fatherid": 0       // 新增(一级相册 传 0 ; 二级或二级以上 传 父相册id); 修改(一级相册 传 相册id ; 二级或二级以上 传 父相册id)
   "albumid": 0        // 新增(一级相册 不传该参数; 二级或二级以上 传 相册id); 修改(一级相册 不传该参数; 二级或二级以上 传 相册id)
 }
 返回数据：
 {
   "code": 0
 }
 */
export const addAlbum = p => jsonp('/api/v4/album/add', p)

/**
 * 云空间删除文件夹（到回收站）接口
 接口路径：api/v4/album/del
 传输方式：post
 参数：json
 {
   "albumid": 1       // 相册id
 }
 返回数据：
 {
   "code": 0
 }
 */
export const delAlbum = p => { return jsonp('/api/v4/album/del', p) }

/**
 * 云空间二级（文件/文件夹）列表接口：
 接口路径：api/v4/space/cloudspacelist
 传输方式：get
 参数：formdata
 currentpage          // 当前页码
 pagesize             // 每页条数
 sortname             // 排序方式: 'name'(名称排序)、'size'(大小排序)、'time'(时间排序)、'hot'(最火排序)
 sortrule             // 排序方式: 1 正序 2 倒叙
 search               // 查询条件: 可选 如 albumid 有值，则搜索该相册下的文件；如 albumid 空值，则搜索全部相册下的文件
 albumid              // 相册id
 albumclass           // 相册分类: 1 个人  2  企业
 isdelete             // 删除标志: 0 正常数据 1 删除的数据
 albumtype            // 相册分类: 暂时无用处  默认值 -1 表示不限制  (0 私有; 1 公开; 2 密码; 3 自定义权限; 5 AI视频; 6 AIGC生图; 7 AI生成海报; 8 海报; 9 默认相册;）
 datatype             // 数据类型: 1 表示 仅查询 jpg bmp 等类型的数据
 返回数据：
 {
   "code": 0,
   "data": {
     "totalCount": 1, // 总条数
     "pageSize": 10,  // 每页条数
     "totalPage": 1,  // 总页数
     "currPage": 1,   // 当前页
     "list": [{
       "albumflag": 2 // （相册/相片）区分标志: 1 相册; 2 相片
     }]
   }
 }
 */
export const cloudSpaceList = p => { return get('/api/v4/space/cloudspacelist', p) }

/**
 * 获取个人二级文件夹下的文件列表接口：
 接口路径：api/v4/tool/aigc/sd/getusergclist
 传输方式：get
 参数：formdata
 currentpage          // 当前页码
 pagesize             // 每页条数
 sortname             // 排序方式: 精选 使用 hot 排序； 创意社区  使用 createtime 或者 love 排序
 followuid            // 他人uid: 0 (默认 不起作用)
 search               // 查询条件: 可选 如 albumid 有值，则搜索该相册下的文件；如 albumid 空值，则搜索全部相册下的文件
 type                 // 相册类型： 6 （默认）
 isshared             // 是否公开： 0  (默认 不起作用)； 1 公开
 workid               // id
 albumid              // 相册id
 outuserid:           // 北航查询学生学号
 返回数据：
 {
   "code": 0,
   "data": {
     "totalCount": 1, // 总条数
     "pageSize": 10,  // 每页条数
     "totalPage": 1,  // 总页数
     "currPage": 1,   // 当前页
     "list": [{
       "albumflag": 2 // （相册/相片）区分标志: 1 相册; 2 相片
     }]
   }
 }
 */
export const getUserFileList = p => { return get('/api/v4/tool/aigc/sd/getusergclist', p) }

/**
 * 获取他人二级文件夹下的文件列表接口：
 接口路径：api/v4/community/gc/getlistbypage
 传输方式：get
 参数：formdata
 currentpage          // 当前页码
 pagesize             // 每页条数
 sortname             // 排序方式: 精选 使用 hot 排序； 创意社区  使用 createtime 或者 love 排序
 followuid            // 他人uid: 0 (默认 不起作用)
 search               // 查询条件: 可选 如 albumid 有值，则搜索该相册下的文件；如 albumid 空值，则搜索全部相册下的文件
 type                 // 相册类型： 6 （默认）
 isshared             // 是否公开： 0  (默认 不起作用)； 1 公开
 workid               // id
 albumid              // 相册id
 返回数据：
 {
   "code": 0,
   "data": {
     "totalCount": 1, // 总条数
     "pageSize": 10,  // 每页条数
     "totalPage": 1,  // 总页数
     "currPage": 1,   // 当前页
     "list": [{
       "albumflag": 2 // （相册/相片）区分标志: 1 相册; 2 相片
     }]
   }
 }
 */
export const getOtherFileList = p => { return get('/api/v4/community/gc/getlistbypage', p) }

/**
 * 相片移动路径接口
 接口路径：/api/v4/tool/aigc/sd/movegc
 传输方式：post
 参数：json
 {
   "gcid": 1          // 相片gcid
   "albumid": 1     // 目标相册id
 }
 返回数据：
 {
   "code": 0
 }
 */
export const moveFile = p => { return jsonp('/api/v4/tool/aigc/sd/movegc', p) }

/**
 * 1. 点赞作品列表（AI视频）：
 api/v4/space/usergc/lovelistpage
 方式：get
 参数：token、albumtype（相片传6，AI视频传5）、currentpage、pagesize
 返回：code、data
 */
export const loveListPage = p => get('/api/v4/space/community/lovelistpage', p)

/**
 * 2.收藏作品列表（AI视频）：
 api/v4/space/usergc/collectlistpage
 方式：get
 参数：token、albumtype（相片传6，AI视频传5）、currentpage、pagesize
 返回：code、data
 */
export const collectListPage = p => get('/api/v4/space/community/collectlistpage', p)

/**
 * 设置相册封面
 */
export const setCover = p => jsonp('/api/v4/tool/aigc/sd/setthumbgc', p) // 设为封面

/**
 * 获取关注/粉丝列表接口：
 api/v1/album/user/followlistpage
 方式：get
 参数：token、uid（如果是查自己的这里不用传，也可传0，查别人的，这里就传对方的uid）、type（1 获取关注列表  2 获取粉丝列表）、nickname（非必传）、currentpage、pagesize
 返回：code，data
 */
export const followListPage = p => get('/api/v1/album/user/followlistpage', p)

/**
 * Authenticationkey 换成token+outuserid
 */
export const getuserinfoForBHU = p => get('/api/v1/cooperation/getuserinfo', p)

/**
 * 腾讯渠道广告点击保存数据接口
 * @param {} p
 * @returns
 */
export const saveAds = p => post('/api/v1/tencent/ads/save', p)

/**
 * 腾讯渠道广告用户行为事件
 * @param {*} p
 * @returns
 */
export const clickAds = p => get('/api/v1/tencent/ads/event', p)

/**
 * 腾讯渠道广告用户行为事件(新)
 * @param {*} jsonp
 * @returns
 */
export const tencentReport = p => jsonp('/api/v1/tencent/ads/report', p)

/**
 * 获取系统通知/消息列表
 * api/v1/user/message/getmessagelist
 * 方式：post（json）
 * 参数：token、type（1系统通知 2 消息）、page、limit、id（查询一条的情况传）、source（传8）
 * return：data
 */
export const getMessageList = p => jsonp('/api/v1/user/message/getmessagelist', p)

/**
 * 系统通知/消息未读消息数量
 * api/v1/user/message/unreadcount
 * 方式：get（json）
 * 参数：token、type（1系统通知 2 消息）、source（传8）
 * return：data
 *
 */
export const unreadCount = p => get('/api/v1/user/message/unreadcount', p)

/**
 * 系统通知/消息查看
 * api/v1/user/message/viewmessage
 * 方式：post（json）
 * 参数：token、id（id 不传（为空） 即全部 已读）、type（1系统通知 2 消息）、source（传8）
 * return：data
 */
export const viewMessage = p => jsonp('/api/v1/user/message/viewmessage', p)

/**
 * 系统通知/消息清空（删除）
 * api/v1/user/message/delete
 * 方式：post（json）
 * 参数：token、id（id 不传（为空） 即全部 删除）、type（1系统通知 2 消息）、source（传8）
 * return：data
 */
export const messageDelete = p => jsonp('/api/v1/user/message/delete', p)

// 改用户名昵称
export const editUserName = p => post('/api/v2/pc/editnickname', p)
// 修改用户头像
export const editavatar = p => post('/api/v2/pc/editavatar', p)

/**
 * 作品举报
 * 请求方式： post （FormData）
 * 入参:
    gcid           // 可为空
    classid        // 可为空
    surl           // 可为空
    ourl           // 可为空
    reasons        // 原因（value）多选用英文逗号，隔开
    description    // 原因描述
    token
 */
export const reportWork = p => jsonp('/api/v2/tool/ai/report/save', p)

/**
 * 生成动漫
 */
export const makingAIAC = data => post('/api/v1/aigc/motioncomics/generate', data)

/**
 * 获取社区数据
 */
export const getCommunityData = data => jsonp('/api/v1/aigc/motioncomics/getlist', data)

/**
 * 视频合并
 */
export const videoMerge = data => jsonp('/api/v99/mp4/merge', data)

/**
 * 闪绘图生图 手工
 * @param {*} data
 *  prompt 描述词
    style 模型  取自  上一个接口 ename 字段
    denoising 变化幅度 1 - 100
    file //以图生图文件
    width  //宽 最大 2000
    height  //高 最大 2000

 * @returns
 */
export const imgGetimgPc = data => post('/api/v3/tool/aigc/sd/imggetimgpc', data)

/**
 * 闪绘图生图 全部
 * @param {*} data
 *  prompt 描述词
    style 模型  取自  上一个接口 ename 字段
    denoising 变化幅度 1 - 100
    file //以图生图文件
    width  //宽 最大 2000
    height  //高 最大 2000

 * @returns
 */
export const imggetimgbyturbo = data => post('/api/v3/tool/aigc/sd/imggetimgbyturbo', data)

/**
 * 普通精修
 * @param {*} data
 * prompt 描述词    // 生成时 缩略图的 描述词
   file //以图生图文件

 */
export const extrasbaseImg = data => post('/api/v3/tool/aigc/sd/extrasbase', data)

/**
 * 超级精修
 * @param {} data
 * @returns
 *file //以图生图文件
  width  //目标宽  最大宽 3000
  height  //目标高 最大高 3000
 */
export const extrasfaceImg = data => post('/api/v3/tool/aigc/sd/extrasface', data)

/**
 * 闪绘百度生成
 *
 *  prompt 描述词
    style 模型  取自  上一个接口 ename 字段
    denoising 变化幅度 1 - 100
    file //以图生图文件
    width  //宽 最大 2000
    height  //高 最大 2000
 * @param {} data
 * @returns
 */
export const baiduFlashDrawing = data => post('/baidu/api/v3/ai/imggetimg', data)

/**
 *获取百度的lora
 * @returns
 */
export const baiduGetLoraList = () => get('/baidu/api/v3/ai/stylelist')

/**
 * 百度的精修
 * @returns
 */
export const baiduRefine = (data) => post('/baidu/api/v3/ai/refine', data)

/**
 * 上报key的接口
 * @param {*} data
 * @returns
 */
export const handShake = data => post('/baidu/api/v3/ai/handshake', data)

/**
 * 闪绘微信小程序: 保存作品
 * @returns
 */
export const saveAIFlashWorks = (data) => jsonp('/api/v4/community/gc/flashsave', data)

/**
 * 闪绘微信小程序: 生图接口
 * 入参说明
 * prompt      描述词（即提示词）
 * style       模型  取自  上一个接口 ename 字段
 * denoising   变化幅度 1 - 100
 * file        以图生图文件
 * width       宽 最大 2000
 * height      高 最大 2000
 * @param {} data
 * @returns
 */
export const miniFlashDrawing = data => post('/vxfp/api/v3/tool/ai/imggetimg', data)

/**
 * 闪绘微信小程序: 获取Lora接口
 * 入参说明
 *
 * @param {} data
 * @returns
 */
export const miniGetLoraList = () => get('/vxfp/api/v3/tool/ai/stylelist')

/**
 * 闪绘微信小程序: 精修接口
 * 入参说明
 *
 * @param {} data
 * @returns
 */
export const miniRefine = (data) => post('/vxfp/api/v3/tool/ai/refine', data)

/**
 * deepseek 增强
 * 入参说明
 *
 * @param {} data
 * @returns
 */
export const postReversePromptToDeepseek = p => jsonp('/api/v4/tool/aigc/sd/getreverseprompt', p)

/**
 * 查询模型分类
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * @param {} data
 * @returns
 */
export const queryLoraGroup = p => get('/api/v3/tool/ai/style/gettypelist', p)

/**
 * 查询模型列表
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * typeid                // 取自查询lora分类 ，0 标识全部
 * name                  // 查询条件 按中文名
 * ename                 // 查询条件按英文名（预留）
 * pagesize              // 每页条数
 * currentpage           // 当前页
 * sortname              // 排序字段  hot 热度 其他 不起作用
 * @param {} data
 * @returns
 */
export const queryLora = p => get('/api/v3/tool/ai/style/listpage', p)

/**
 * 根据模型英文名称获取模型列表
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * enames                // 多个英文名称 用 ,分割
 * @param {} data
 * @returns
 */
export const getLoraByEName = p => get('/api/v3/tool/ai/style/getbyename', p)

/**
 * 查询用户收藏的模型列表
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * pagesize              // 每页条数
 * currentpage           // 当前页
 * @param {} data
 * @returns
 */
export const getUserCollectLoraList = p => get('/api/v3/tool/ai/style/getusercollectlist', p)

/**
 * 查询用户最近使用的模型
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * source                // 来源
 * pagesize              // 每页条数
 * currentpage           // 当前页
 * @param {} data
 * @returns
 */
export const getUserUsedLoraList = p => get('/api/v3/tool/ai/style/getuserusedlist', p)

/**
 * 用户收藏模型
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * ename                 // 模型英文名称
 * @param {} data
 * @returns
 */
export const collectLora = p => jsonp('/api/v3/tool/ai/style/collect', p)

/**
 * 用户取消收藏模型
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * ename                 // 模型英文名称
 * @param {} data
 * @returns
 */
export const cancelCollectLora = p => jsonp('/api/v3/tool/ai/style/cancelcollect', p)

/**
 * 查看某个模型是否收藏了
 * 入参说明
 * modelgroup            // lora loraflux turbo
 * ename                 // 模型英文名称
 * @param {} data
 * @returns
 */
export const checkLoraCollected = p => get('/api/v3/tool/ai/style/checkcollected', p)

/**
 * 启动动态漫画视频生成任务
 * 根据用户提供的多模态提示词序列（文本/图片/视频/音频）和参考媒体文件，调用火山引擎 AI 服务生成视频。
 * 返回任务 ID，后续可通过任务查询接口获取结果。
 *
 * @param {Object} p - MotionComicsParam 参数对象
 * @param {string} p.type - 固定值 "gcvideo"
 * @param {string} p.style - 模型英文名（如 "anime_v1"）
 * @param {string} [p.prompt] - 已废弃，使用 promptlist 代替
 * @param {boolean} [p.generateaudio=true] - 是否生成音频
 * @param {string} [p.fileurl] - 首帧图片 URL
 * @param {string} [p.lastframefileurl] - 尾帧图片 URL
 * @param {string} [p.ratio] - 画面比例（如 "16:9"、"9:16"）
 * @param {number} [p.duration=6] - 视频时长（秒）
 * @param {string} [p.resolution="N"] - 分辨率：L(480p) / N(720p) / H(1024p) / L-V(540p)
 * @param {Array<Object>} p.promptlist - 多模态提示词序列，每项包含 type 和 value：
 *   - type: "TEXT" / "IMG" / "VIDEO" / "AUDIO"
 *   - value: 文本内容 或 媒体文件URL（URL需在 referencelisturls 中存在）
 * @param {Array<Object>} [p.referencelisturls] - 参考媒体文件列表，每项包含：
 *   - type: "IMG" / "VIDEO" / "AUDIO"
 *   - value: 媒体文件 URL
 * @returns {Promise<Object>} 返回格式示例：
 *   {
 *     code: 0,
 *     data: {
 *       taskId: "abc123xyz"   // 任务ID，用于轮询结果
 *     }
 *   }
 * @example
 * // 请求示例
 * startVideoGeneration({
 *   type: "gcvideo",
 *   style: "anime_v1",
 *   duration: 8,
 *   ratio: "16:9",
 *   resolution: "N",
 *   promptlist: [
 *     { type: "TEXT", value: "一只猫坐在窗台上，" },
 *     { type: "IMG", value: "https://example.com/cat.jpg" },
 *     { type: "TEXT", value: "然后跳下窗户。" }
 *   ],
 *   referencelisturls: [
 *     { type: "IMG", value: "https://example.com/cat.jpg" ,"assetid":"asset-20260224200602-qn7wr"}// 如果是 素材库中的图 传素材ID ，否则传空
 *   ]
 * });
 */
export const startVideoGeneration = p => jsonp('/api/v1/aigc/motioncomics/gc', p)
/**
 * // 请求示例
 * subjectRecognize({
 *   imageUrl: "https://example.com/input-face.jpg"
 * });
 * // 返回: { code: 0, msg: "success", data: null }
 * // 返回 "没有人脸" 时 code != 0
 */
export const subjectRecognize = p => jsonp('/api/v1/aigc/motioncomics/subjectRecognize', p)

/**
 * // 请求示例
 * detectSubject({
 *   imageUrl: "https://example.com/input-face.jpg"
 * });
 * // 返回: { code: 0, msg: "success", data: ["https://cdn.../mask1.png", "https://cdn.../mask2.png"] }
 * // mask 已自动上传到七牛
 */
export const detectSubject = p => jsonp('/api/v1/aigc/motioncomics/detectSubject', p)
